import {Button, Menu, MenuDivider, Spinner, Classes, MenuItem} from '@blueprintjs/core'
import {FlexLayoutDockMenuItem} from '@stores/catalog/flexLayout/flexComponents'
import {PdfSvgIcon} from '@stores/ui'
import {PrimaryIconButton} from 'centric-ui-components'
import {runInAction} from 'mobx'
import * as css from './ReportHeaderChip.css'
import {Popover2, _, React, observer, observable, computed, action, classNames, useAsObservableSource, autorun, jsondiff, useEffect, Fragment, Tooltip2, Keys} from '@api'
import {ContextMenuItem, OtherNewFlexTabMenuItems, useStores, useVipLocalStore, VipLocalStore, WorkspaceChooserMenuItems} from '@modules'
import {ICatalogReportEs, icons, ReportWrapper, StoresInstance} from '@stores'
import {FormControlLabel, Grid, Switch, TextField, Tooltip} from '@material-ui/core'

/// region Store

export class ReportHeaderChipStore extends VipLocalStore {
  constructor(stores: StoresInstance, public props: Partial<MyProps>) {
    super(stores)
  }

  get report() {
    return this.props.report
  }

  @action onNavigateToReport = (e: React.MouseEvent) => {
    const {props: {report: {isCurrentReport, navigateTo}}} = this

    !isCurrentReport && navigateTo()
  }

  @action onDeleteReport = async (e: React.MouseEvent) => {
    const {stores: {currentUser, reports, reports: {recentReports}, catalog: {idFor}}, props: {report}} = this, reportId = idFor(report)

    e?.stopPropagation()
    reports.recentReports = (recentReports ?? []).filter(id => id !== reportId)

    if (confirm(`Delete this report?`)) {
      await report.deleteReport()
    }
  }
}

export const ReportHeaderChipStoreContext = React.createContext<ReportHeaderChipStore>(null)
export const useReportHeaderChipStore = () => React.useContext(ReportHeaderChipStoreContext)

/// endregion

/// region Components

interface MyProps {
  className?: string
  report: ReportWrapper
  index: number
}

/// endregion

export const ReportHeaderChip = observer<MyProps>(function ReportHeaderChip({className, report, index}) {
  const {report: {title, creator}} = report

  const obsProps = useAsObservableSource({report, index}),
    store = useVipLocalStore((stores) => new ReportHeaderChipStore(stores, obsProps)),
    {
      onNavigateToReport, onDeleteReport,
      stores: {
        flexLayout: {activeTab, isMaximized, toggleMaximize, create: {onNewWorkspaceItem}},
        reports: {createReport, defaultReportId, openDefaultReport, reportUserId, currentReport}, currentUser: {userSettings}, ui: {settings: {reports: {draftReports}}}
      },
      report: {onEditReportDetails, onEditReportPDFDetails, /* navigatedFromDraft, drafts, isDraft, toggleShowOriginal, publishDraft,discardDraft*/ isMyReport, saveCopy, isDirty}
    } = store

  return (
    <ReportHeaderChipStoreContext.Provider value={store}>
      <Popover2
        position='bottom-right'
        modifiers={{
          offset: {
            enabled: true,
            options: {
              offset: [0, -2]
            }
          }
        }}
        minimal
        interactionKind='hover'
        content={<Menu>
          <ContextMenuItem text='New Report' icon='document' onClick={() => createReport(true)}/>
          <MenuDivider />
          <PublicReportsMenuItem />
          <MyReportsMenuItem />
          <MenuDivider />

          {false && <ContextMenuItem shouldDismissPopover={false} text={`Open Report...`} icon={'folder-open'}
                           popoverProps={{className: css.openReportsSubmenu, ...MenuItem.defaultProps.popoverProps}}>
            {/*<ContextMenuItem text='Open a Report' icon='folder-open'/>*/}
            {/*<MenuDivider title='Recently Opened'/>*/}
            <RecentReportMenuItems/>
            {/*<RecentlyOpenedReportMenuItems/>*/}
          </ContextMenuItem>}

          <ContextMenuItem text='Edit Report Details...' icon='edit' onClick={onEditReportDetails}/>
          {DEBUG && <ContextMenuItem text='Generate PDF...' icon={<PdfSvgIcon/>} onClick={onEditReportPDFDetails}/>}
          {currentReport &&
		   <Fragment>
			   <ContextMenuItem dividerBefore text='My Default Report?' icon={currentReport?.isMyDefaultReport ? 'tick' : 'bookmark'} onClick={currentReport.toggleMakeReportMyDefault}/>
             {currentReport && defaultReportId && defaultReportId != currentReport.id && <ContextMenuItem text='Open Default Report' icon={'book'} onClick={openDefaultReport}/>}
			   <MenuDivider/>
		   </Fragment>}
          <ContextMenuItem active={currentReport?.isMyReport && userSettings.autoSaveReports === true} text='Auto-save Report Changes' disabled={!currentReport?.isMyReport} onClick={() => userSettings.autoSaveReports = !userSettings.autoSaveReports}/>
          {!userSettings.autoSaveReports && report?.isMyReport && <ContextMenuItem icon='cloud-upload' text='Save Report' onClick={currentReport.saveChanges}/>}
          {currentReport?.isLocalDraft && <ContextMenuItem icon='reset' text='Discard Changes' onClick={currentReport.discardLocalChanges} />}
          <ReportSaveAsMenuItem/>
          {draftReports && <Fragment>
            {/*{isDraft && isMyReport && <ContextMenuItem icon='floppy-disk' text='Save Changes' onClick={publishDraft}/>}*/}
            {/*{isDraft && isMyReport && <ContextMenuItem disabled={report.originalReport == null} icon='trash' text='Revert Changes' onClick={() => discardDraft()}/>}*/}
		  </Fragment>}


          {/*{isDraft || navigatedFromDraft ? <ContextMenuItem text='Show Original Version'*/}
          {/*                                                  onClick={toggleShowOriginal}*/}
          {/*                                                  icon={!isDraft ? 'tick' : 'blank'}/>*/}
          {/*                               : _.isEmpty(drafts) ? null*/}
          {/*                                                   : <ContextMenuItem text='Drafts' icon='edit'>*/}
          {/*                                   {(drafts ?? []).map((draft, i) => <ReportMenuItem report={draft} key={i}/>)}*/}
          {/*                                 </ContextMenuItem>}*/}

          {/*<MenuDivider/>*/}
          {false && !isMaximized &&
		   <ContextMenuItem text='Layout' icon='layout'>
			   <MenuDivider/>
			   <FlexLayoutDockMenuItem/>
		   </ContextMenuItem>}
          <ContextMenuItem dividerBefore disabled={reportUserId !== creator} icon='trash' onClick={onDeleteReport} text='Delete this Report'/>
        </Menu>}
      >
        <Button className={classNames(css.root, className)}
                minimal
                icon={icons.flexLayout}
                onClick={onNavigateToReport}
          //data-selected={isSelected}
                data-id={report.id}
                text={
                  <span className={css.title}>
        {title ? title : `My Report`}
                    {(isDirty || currentReport?.isLocalDraft) && <Tooltip title='You have Unsaved Changes'><span className={css.dirty}>*</span></Tooltip>}
                    {/*{isDraft && <Tooltip2 content='Draft Version' position='bottom'><span className={css.draft}></span></Tooltip2>}*/}
      </span>
                }
                rightIcon={report.saving ? <Spinner size={16} className={css.spinner}/> : 'caret-down'}
        />
      </Popover2>
    </ReportHeaderChipStoreContext.Provider>)
})
//isSelected && reportUserId === creator ? <PrimaryIconButton className={css.close} icon='cross' onClick={onClickClose}/> : undefined}

export const ReportSaveAsMenuItem = observer(function ReportSaveAsMenuItem() {
  const {reports: {onSaveAs_start}} = useStores()

  return (<ContextMenuItem icon='floppy-disk' text='Save As...' onClick={onSaveAs_start}/>)
})

export const NewReportHeaderChip = observer(function NewReportHeaderChip() {
  const {reports} = useStores()
  return (
    <div className={classNames(css.root, css.newReport)}
         onClick={async () => await reports.createReport(true)}>
      <span className={css.title}>
        Create New Report
      </span>
    </div>)
})

export const PublicReportsMenuItem = observer(function PublicReportsMenuItem() {
    const {reports: {publicReports}} = useStores()

    return (
      <ContextMenuItem
    icon='people'
    text='Public Reports'
    disabled={_.isEmpty(publicReports)}
    >
        {publicReports.map(r => <ReportMenuItem key={r.id} report={r} openAsPublicReport showUserLabel/>)}
      </ContextMenuItem>)
})

export const MyReportsMenuItem = observer(function MyReportsMenuItem() {
  const {reports: {myReports}} = useStores()

  return (<ContextMenuItem
    icon='folder-open'
    text='My Reports'
    disabled={_.isEmpty(myReports)}
  >
    {myReports.map(r => <ReportMenuItem key={r.id} report={r} />)}
  </ContextMenuItem>)
})

// /*
//  <PublicReportsMenuItem />
//           <MyReportsMenuItem />
//           <ContextMenuItem shouldDismissPopover={false} text={`Open Report...`} icon={'folder-open'}
//                            popoverProps={{className: css.openReportsSubmenu, ...MenuItem.defaultProps.popoverProps}}>
//             {/*<ContextMenuItem text='Open a Report' icon='folder-open'/>*/
// }
// {/*<MenuDivider title='Recently Opened'/>*/}
// <RecentReportMenuItems/>
// {/*<RecentlyOpenedReportMenuItems/>*/}

export const ReportMenuItem = observer<{ report: ReportWrapper, openAsPublicReport?: boolean, showUserLabel?: boolean }>(function ReportMenuItem({report, showUserLabel, openAsPublicReport}) {
  const {displayName, isDraft, isMyReport, isPublic, toggleIsPublic, id, isCurrentReport, isMyDefaultReport, makeDefaultReport, deleteReport, publishDraft, discardDraft, cloneReport} = report

  return (<Fragment>
    <ContextMenuItem active={isCurrentReport}
                     icon={isMyDefaultReport ? 'badge' : isCurrentReport ? 'tick' : 'blank'}
                     onClick={() => report.navigateTo(openAsPublicReport)}
                     data-my-report={report.isMyReport}
                     text={displayName}
                     label={showUserLabel ? report.creator?.name : isPublic ? 'Public' : undefined}
                     className={css.reportMenuItem}
                     data-id={id}
                     labelElement={isDraft ? <span className={css.draft}>(Draft)</span> : null}
    >
      {/*<ContextMenuItem text={`${report.report.creator}`} />*/}
      {/*<MenuDivider />*/}
      <ContextMenuItem icon='duplicate' text='Clone Report' onClick={() => cloneReport()}/>
      <ContextMenuItem icon='badge' text='Make Default' onClick={makeDefaultReport}/>
      {isMyReport && <ContextMenuItem active={isPublic} text='Make Public' onClick={toggleIsPublic}/>}

      {!isMyReport && !DEBUG ? undefined :
       <Fragment>
         <ContextMenuItem icon='trash' text='Delete Report' onClick={() => deleteReport(false)}/>
         {isDraft && <Fragment>
			 <ContextMenuItem icon='floppy-disk' text='Save Draft' onClick={publishDraft}/>
			 <MenuDivider/>
			 <ContextMenuItem icon='trash' text='Discard Draft' onClick={() => discardDraft()}/>
		 </Fragment>}
       </Fragment>}
    </ContextMenuItem>
  </Fragment>)
})

export const RecentReportMenuItems = observer(function RecentReportMenuItems() {
  const {reports: {recentReports, reportById, lastOpenedReports}} = useStores(),
    toRender = _.sortBy(
      recentReports.filter(r => r.isDraft || !recentReports.some(v => v.isDraft && v.report.draftedFrom.id == r.id)),
      v => {
        const openedIndex = lastOpenedReports.indexOf(v)
        return openedIndex !== -1 ? openedIndex : (lastOpenedReports.length + (v.isMyReport ? 1 : 2))
      })

  return (<Fragment>
    {toRender.map((r, i) => <ReportMenuItem key={i} report={r}/>)}
  </Fragment>)
})



// WEBPACK FOOTER //
// ./src/stores/catalog/flexLayout/ReportHeaderChip.tsx